// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__13Jj4","options":"AnswerScale_options__vRI7k","selected":"AnswerScale_selected__naN4C"};